import { getFieldValue } from "@sitecore-jss/sitecore-jss-react";
import { Helmet } from "react-helmet";
import React from "react";

const EloquaIntegrationData = ({ fields }) => {
  const divisionCode = getFieldValue(fields, "divisionCode");
  const eloquaId = getFieldValue(fields, "eloquaId");

  return <></>;
};

export default EloquaIntegrationData;
